import * as React from "react";
import { connect } from "react-redux";
import IProps from "./IProps";
import ReviewCard from "./component/reviewCard";
import { bindActionCreators } from "redux";
import * as adminActionCreators from "../../components/AdminDashboard/actionCreators";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
/**
 * @Interface IState
 * @description This class will basically be used to show more details page
 * @ignore
 */
interface IState {
    items: any;
}
/**
 * @class ReviewContainer
 * @description This class is the main container of review and pay widget
 * and will make an API call. And pass on the Object to next level for painting the
 * Object.
 * @category Main Component
 */
class ReviewContainer extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {
            warrantyId,
            formId,
            isSubmittedForm,
            dynamicFormActions: { getReviewAndPayData, getErrorResponseOnNavChange },
        } = this.props;
        // getReviewAndPayData({ payload: isSubmittedForm ? warrantyId : 0 });
        getReviewAndPayData({ payload: warrantyId });
        if (this.props.isSubmittedForm) {
            getErrorResponseOnNavChange({ id: warrantyId ? warrantyId : formId });
        }
    }

    onWaiverCheck = (e) => {
        const {
            adminActions: { updateWaiverReceived },
        } = this.props;
        updateWaiverReceived(e.target.checked);
    };

    /**
     * @function render
     * @description This function will be used to render the page in
     * With show more data by constructing the form from the incomming data
     * via API call
     */
    render() {
        const { reviewAndPayData, userInfo, waiverReceived, schema } = this.props;
        const tabIndex = schema.const.tabIndex;
        let warrantyCost;
        if (reviewAndPayData && reviewAndPayData.residentialWarranty) {
            warrantyCost =
                reviewAndPayData.residentialWarranty.cost || reviewAndPayData.residentialWarranty.cost === 0
                    ? parseFloat(reviewAndPayData.residentialWarranty.cost)
                    : 0.0;
            warrantyCost = warrantyCost.toFixed(2);
        }
        let navMenuVal = -1;
        return (
            <div className="gaf-main-review-container ">
                {/* - provision for total cost can be used here - */}
                <div className="gaf-over-view-container justify-content-between">
                    <span className="overview-header">Overview</span>
                    <span className="totalcost">Total Warranty Cost: ${warrantyCost}</span>
                </div>

                {reviewAndPayData.residentialWarranty &&
                    //delete reviewAndPayData.residentialWarranty.cost &&
                    Object.keys(reviewAndPayData.residentialWarranty).map((items, index) => {
                        if (items != "cost") {
                            navMenuVal += 1;
                            return (
                                <ReviewCard
                                    key={`card ${index}`}
                                    titleinfo={items}
                                    cardindex={navMenuVal}
                                    content={reviewAndPayData.residentialWarranty[items]}
                                    tabIndex={tabIndex}
                                />
                            );
                        }
                    })}

                {userInfo && userInfo.isAdmin && (
                    <div className="section-container formContainer commonFormTemplate gaf-review-container-holder waiver-container">
                        <div className="gaf-summary-title">Waiver</div>
                        <label className={`waiver-checkbox  ${waiverReceived ? "checked" : "unchecked"}`}>
                            <input
                                id="waiver-checkbox-input"
                                checked={waiverReceived}
                                type="checkbox"
                                className="hide-checkbox"
                                onClick={this.onWaiverCheck}
                            />
                        </label>
                        <div className="checkbox-label">Waiver received</div>
                    </div>
                )}
                <div className="gaf-over-view-container-bottom justify-content-between warrany-cost">
                    <span className="totalcost">Total Warranty Cost: ${warrantyCost}</span>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        userInfo: state.adminData.userInfo,
        waiverReceived: state.adminData.waiverReceived,
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        reviewAndPayData: state.dynamicFormInfo.reviewAndPayData,
        isSubmittedForm: state.adminData.isSubmittedForm,
        formLayout: state.dynamicFormInfo.layoutResponse,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        adminActions: bindActionCreators(adminActionCreators, dispatch),
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewContainer);
